import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  accessToken: '',
  refreshToken: '',
  latestTokenUpdated: undefined,
};

type TypeTokenStore = {
  /** 유저 인증 정보 토큰 */
  accessToken: string;
  /** 유저 인증 정보 토큰 재발급을 위한 보안 토큰
   * @description 자동 로그인 상태를 비활성화하면 발급되지 않음
   */
  refreshToken: string;
  /** 마지막으로 토큰이 갱신된 시간
   * @description 불필요한 토큰 재갱신을 하지 않기 위해 사용
   */
  latestTokenUpdated?: string;
  actions: {
    setAccessToken: (token: string) => void;
    setRefreshToken: (token: string) => void;
    setLatestTokenUpdated: (latestTokenUpdated: string) => void;
    resetTokens: () => void;
  };
};

/** @description 상태를 로컬 스토리지에 저장하기 위한 키 */
const keyOfStorage = 'token';

/** @description 토큰 관련 정보를 저장하는 상태 */
export const useTokenStore = create<TypeTokenStore>()(
  persist(
    (set) => ({
      ...initialState,
      actions: {
        setAccessToken: (token: string) => set({ accessToken: token }),
        setRefreshToken: (token: string) => set({ refreshToken: token }),
        setLatestTokenUpdated: (latestTokenUpdated: string) => set({ latestTokenUpdated }),
        resetTokens: () => {
          set({ ...initialState });
          localStorage.removeItem(keyOfStorage);
        },
      },
    }),
    {
      name: keyOfStorage,
      version: 1,
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        latestTokenUpdated: state.latestTokenUpdated,
      }),
      migrate: (persistedState, currentVersion) => {
        // UI/UX 개선 전 로컬스토리지에 저장된 값 삭제
        if (currentVersion < 1) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('latestTokenUpdated');
          localStorage.removeItem('isRefreshingToken');
        }
        return persistedState;
      },
    }
  )
);
